import React from "react";
import Table from "../../components/table/HelpTable";
import PropTypes from "prop-types";

const ColumnDictionaryContent = ({ content }) => {
    const columns = [
        {
            Header: "Column Name",
            accessor: "Column Name",
            width: 220,
        },
        {
            Header: "Definition",
            accessor: "Definition",
            Cell: ({ row }) => (
                <div>
                    <div style={{ whiteSpace: "pre-line" }}>
                        {row.original.Definition}
                    </div>
                </div>
            ),
        },
    ];

    return (
        <>
            {content.length > 0 ? (
                <Table
                    columns={columns}
                    data={content}
                    filterHeader="Column Name"
                    responsiveConfig={{
                        type: "COLUMN",
                        striped: false,
                        screen: "md",
                    }}
                    className="reference-table"
                />
            ) : (
                <div style={{ width: "610px" }}>
                    <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                            margin: "0px",
                            height: "50px",
                            padding: "0px 32px",
                        }}
                    >
                        No Data
                    </div>
                </div>
            )}
        </>
    );
};

ColumnDictionaryContent.propTypes = {
    content: PropTypes.array,
};

export default ColumnDictionaryContent;
